function n() {
  return Array.from(crypto.getRandomValues(new Uint8Array(4)), (r) => `0${(255 & r).toString(16)}`.slice(-2)).join("");
}
export {
  n as r
};
//# sourceMappingURL=random-id-aENvrLj2.js.map
